<template>
  <!-- <i class="fas fa-school text-xl" :class="[`${item.loaihinh_id == 1 ? 'text-orange-500' : item.loaihinh_id == 2 ? 'text-orange-500' : 'text-rose-600'}`]"></i> -->
  <div class="relative inline-block">
    <!-- Marker background -->
    <div class="text-white rounded-full flex items-center justify-center shadow-md" :class="[props.bgColor]">
      <i :class="props.classIcon"></i>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  bgColor: {
    type: String,
    required: true
  },
  classIcon: {
    type: String,
    required: true
  },
  title: {
    type: String
  }
});
</script>

<style></style>